/* import __COLOCATED_TEMPLATE__ from './preview-selector.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

export default class PreviewSelector extends Component {
  @service intersectionService;
  @service intercomEventService;

  constructor(...args) {
    super(...args);
    // Keep this here for legacy reason, we need to ship the new handler below, update intersection and then delete this one
    this.intersectionService.registerEventHandler('getCustomBot', (data) => {
      return {
        id: this.args.previewableWorkflow.id,
        composerSuggestions: this.previewConfiguration.composerSuggestions,
        title: this.previewConfiguration.previewTitle,
      };
    });
    this.intersectionService.registerEventHandler('getWorkflowable', (data) => {
      return {
        workflowInstanceId: this.args.previewableWorkflow.latestWorkflowInstanceId,
        composerSuggestions: this.previewConfiguration.composerSuggestions,
        title: this.previewConfiguration.previewTitle,
      };
    });
    this._trackFinPreviewEvent();
  }

  get reactPreviewConfig() {
    let workflow = this.args.previewableWorkflow;
    if (workflow.isAiAgentWorkflowTrigger) {
      return {
        type: 'workflows',
        workflowId: workflow.id,
        previewType: this.args.previewType,
        draftEntityId: this.args.previewDraftEntityId,
        draftEntityType: this.args.previewDraftEntityType,
        draftVersionId: this.args.previewDraftVersionId,
        skipGateChecks: true,
      };
    }
    return {
      type: 'workflows',
      workflowInstanceId: workflow.latestWorkflowInstanceId,
      skipGateChecks: true,
    };
  }

  get previewConfiguration() {
    return this.args.previewableWorkflow.previewConfiguration;
  }

  _trackFinPreviewEvent() {
    if (!this.args.previewableWorkflow.useAiAnswers) {
      return;
    }
    this.intercomEventService.trackEvent('launched-fin-preview');
  }

  @action
  closeModal() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'closed',
      section: 'operator',
      place: 'custom_bots',
      object: 'preview_modal',
    });

    this.args.closeModal();
  }
}
